<template>
  <div style="direction: ltr">
    <div class="main-content">
      <div>
        <!-- عنوان -->
        <el-card
          shadow="never"
          style="margin-bottom: 20px"
          v-loading="deviceStore.isLoading"
        >
          <div style="font-weight: bold; font-size: 18px">
            خلاصه وضعیت {{ deviceStore.activeArea?.name }}
          </div>
        </el-card>
        <div
          class="container-total-card"
          style="margin-bottom: 20px"
          v-loading="totalData == null"
        >
          <div class="total-card">
            <p>حجم آب مصرف شده از ابتدا</p>
            <b>{{ totalData?.total }}</b
            >m<sup>3</sup>
          </div>
          <div class="total-card">
            <p>حجم آب مصرف شده ماه جاری</p>
            <b>{{ totalData?.monthly }}</b
            >m<sup>3</sup>
          </div>
          <div class="total-card">
            <p>حجم آب مصرف شده 7 روز گذشته</p>
            <b>{{ totalData?.weekly }}</b
            >m<sup>3</sup>
          </div>
          <div class="total-card">
            <p>حجم آب مصرف شده امروز</p>
            <b>{{ totalData?.today }}</b
            >m<sup>3</sup>
          </div>
        </div>

        <el-row :gutter="10" class="flex-wrap custom-height">
          <!-- چارت بالا سمت چپ -->
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <el-card v-loading="todayChartData == null">
              <div
                v-if="todayChartData == null || todayChartData?.length == 0"
                class="card highlight"
                :style="{
                  height: isMobile ? '230px' : '450px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: isMobile ? '14px' : '18px',
                  color: '#999',
                  fontWeight: 'bold',
                }"
              >
                دیتایی برای رسم نمودار مصرف آب روزانه وجود ندارد
              </div>
              <BaseChart
                v-else
                class="card highlight"
                type="line"
                :height="chartHeight"
                :isMobile="isMobile"
                report="1"
                title="حجم آب عبوری در شبانه‌ روز"
                :categories="todayChartData[0]?.categories || []"
                :data="todayChartData[0]?.data || []"
                mode="daily"
                name="حجم آب عبوری"
              />
            </el-card>
          </el-col>

          <!-- جدول پایین -->
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            class="custom-card-height"
          >
            <el-row :gutter="16" class="device-list">
              <el-col
                v-for="device in detailsWellData"
                :key="device.id"
                :xs="24"
                :sm="12"
                :md="8"
                :lg="6"
              >
                <el-card shadow="hover" class="device-card">
                  <div class="header-status-device">
                    <div class="name-status-device">{{ device.name }}</div>
                    <el-tag
                      size="small"
                      :type="device.status ? 'success' : 'info'"
                    >
                      {{ device.status ? "روشن" : "خاموش" }}
                    </el-tag>
                  </div>

                  <!-- <div class="switch-wrapper-status-device">
                    <el-switch
                      v-model="device.status"
                      :disabled="true"
                      active-color="#13ce66"
                      inactive-color="#dcdfe6"
                    />
                  </div>-->
                </el-card>
              </el-col>
            </el-row>
          </el-col>
          <el-col :md="24" class="custom-card-height"
            ><div style="height: 50px"></div
          ></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  onBeforeUnmount,
  watch,
  computed,
  reactive,
  onUnmounted,
} from "vue";
import jmoment from "moment-jalaali";
import BaseChart from "@/components/BaseChart.vue";

import { useDeviceStore } from "@/stores/device";
import { showToast } from "@/utils/toastHelper";
import {
  fetchReportCommandCount,
  fetchReportFlowmeter,
  getLastExpenseWaterforWell,
} from "@/services/auth";
import socket from "@/services/socket";

const deviceStore = useDeviceStore();

const isMobile = ref(false);
const chartHeight = ref("370px");
const totalData = ref(null);
const loading = ref(true);
const detailsWellData = ref(null);
const todayChartData = ref(null);

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
  chartHeight.value = isMobile.value ? "250px" : "390px";
};

onMounted(() => {
  const token = localStorage.getItem("token");
  if (token) {
    socket.connect(token);
    socket.joinRoom("manger");
  }
});
onMounted(() => {
  window.addEventListener("resize", checkMobile);

  checkMobile();
  if (deviceStore.activeArea) {
    callNextApi();
  }
});
/*
onBeforeUnmount(() => {
  socket.disconnect();
  window.removeEventListener("resize", checkMobile);
});*/
watch(
  () => deviceStore.activeArea,
  (newVal, oldVal) => {
    if ((newVal && oldVal==null)||newVal && oldVal?.id!=newVal?.id) {
      //
      //loading.value=true
    
      if (!socket.connected) return; // اگر هنوز کانکت نیستیم کاری نکن
      totalData.value = null;
      detailsWellData.value = null;
      todayChartData.value = null;
      callNextApi();

      //  if (oldVal?.pin) socket.leaveRoom(oldVal.pin);

      /*  if (newVal?.pin) {
        socket.joinRoom(newVal.pin);
        getStatusWell();
      }*/
    }
  },
  { immediate: true }
);

const formatWeek = (dates) => {
  if (!Array.isArray(dates)) return [];
  return dates.map((d) => {
    const jm = jmoment(d, ["jYYYY/jMM/jDD HH:mm", "jYYYY/jMM/jDD"], true);
    if (!jm.isValid()) return d;
    let dayName = jm.format("dddd");
    if (dayName === "آدینه") dayName = "جمعه";
    return dayName;
  });
};

function checkAddPoint(id, time, daily, total) {
  if (
    todayChartData == null ||
    todayChartData?.value == null ||
    todayChartData?.length == 0
  )
    return;
  const index = todayChartData.value[0].data.findIndex((item) => item.id == id);

  if (index !== -1) {
    //console.log("🟢 پیدا شد در اندیس:", index);
    // console.log(todayChartData.value[0].data[index])
    addPoint(time, daily, id, index);
    checkStatusWell(0, id, total, "water");
  } else {
    //console.log("🔴 پیدا نشد");
  }
}

const addPoint = (x, y, id, index) => {
  const lastIndex = todayChartData.value[0].data[index].categories.length - 1;

  if (
    lastIndex >= 0 &&
    todayChartData.value[0].data[index].categories[lastIndex] == x
  ) {
    // اگر x تکراری بود → میانگین بگیر
    const oldY = todayChartData.value[0].data[index].data[lastIndex];
    if (oldY == null) {
      todayChartData.value[0].data[index].data[lastIndex] = y; // اگر قبلی null بود فقط جدید رو بذار
    } else {
      todayChartData.value[0].data[index].data[lastIndex] = (oldY + y) / 2;
    }
  } else {
    // اگر جدید بود → push کن
    todayChartData.value[0].data[index].data.push(y);
    todayChartData.value[0].data[index].categories.push(x);
  }
};
function checkStatusWell(status, id, total, type) {
  detailsWellData.value = detailsWellData.value.map((item) => {
    if (item.id != id) return item; // فقط آیتم موردنظر را آپدیت می‌کنیم

    if (type == "water") {
      // حالت بار اول: start و end null
      if (item.start == null && item.end == null) {
        return { ...item, start: total, end: null };
      }

      // حالت دوم: start دارد و end null
      if (item.start != null && item.end == null) {
        return { ...item, end: total };
      }

      // حالت سوم: هر دو مقدار دارند، محاسبه فاصله و آماده‌سازی بازه بعدی
      if (item.start != null && item.end != null) {
        const diff = item.end - item.start;
        totalData.today += diff;
        totalData.weekly += diff;
        totalData.monthly += diff;
        totalData.total += diff;

        return { ...item, start: item.end, end: null };
      }
    } else {
      return { ...item, status: status };
    }

    return item; // fallback
  });
}
setTimeout(() => {
  // socket.joinRoom("manger");
  socket.emit("dashboard/data/request", {
    level: "area",
    id: deviceStore.activeArea.id,
  });
  if (deviceStore.activeArea) {
    callNextApi();
  }
  socket.on("flowmeter/today", (data) => {
    //console.log(data)
    checkAddPoint(data?.id, data.xAxis, data.yAxis, data.total);
  });
  socket.on("dashboard/total/water", (data) => {
    totalData.value = data;
    // console.log(data)
    //  console.log(totalData.value)
  });
  socket.on("motor/status", (data) => {
    if (data.status == 2) return;
    checkStatusWell(data.status, data.id, 0, "motor");
    //deviceStore.updateActiveDeviceStatusWell(data.status);

    showToast(
      (data.status == 1 ? " روشن کردن پمپ " : " خاموش کردن پمپ ") +
        " با موفقیت انجام شد ",
      "success"
    );
  });
}, 2000); // ۲ ثانیه بعد از اجرا
onUnmounted(() => {
  socket.off("flowmeter/today");
  socket.off("motor/status");
  socket.leaveRoom("manger");

  console.log(`❌ Left area`);
});

async function callNextApi() {
  // loading.value = true;

  //console.log("callNextApiiiiiiiiiiiiiiii");

  try {
    socket.emit("dashboard/data/request", {
      level: "area",
      id: deviceStore.activeArea.id,
    });
    detailsWellData.value = await getLastExpenseWaterforWell(
      deviceStore.activeArea.id
    );
    const chartData = await fetchReportFlowmeter({
      ids: [deviceStore.activeArea.id],
      reportType: 0,
      level: "area",
      type: 1,
    });
    const list = Array.isArray(chartData?.data?.list)
      ? chartData.data.list
      : [];

    todayChartData.value = list
      .filter((item) => item.series && item.series.length) // فقط موارد با سری‌ها
      .map((item) => {
        if (item.type == "multi-line") {
          const allCategoriesSet = new Set();
          item.series.forEach((s) =>
            s.xAxis?.forEach((d) => allCategoriesSet.add(d))
          );
          const allCategories = Array.from(allCategoriesSet).sort();

          return allCategories.length > 0
            ? {
                type: "line",
                categories: allCategories.map(String),
                data: item.series.map((s) => ({
                  name: s.name,
                  id: s.id,
                  data: s.yAxis || [],
                  categories: s.xAxis?.map(String) || [],
                  unit: "مترمکعب/ساعت",
                })),
              }
            : null;
        }
      });
  } catch (error) {
    if (error.response && error.response.status === 401) {
      deviceStore.reset();
      window.location.href = "/login";
    } else {
      console.error("خطای دیگر:", error);
    }
  }
}
</script>

<style scoped>
.mobile-header {
  background-color: #205685;
  color: white;
  display: flex;
  align-items: center;
  height: 60px;
  direction: rtl;
}
.main-content {
  padding: 1rem;
}
.main-container {
  direction: ltr;
}
.custom-height {
  display: flex !important;
  align-items: stretch !important;
  height: 380px;
}
.custom-card-height {
  display: flex !important;
  flex-direction: column !important;
}
.el-col {
  margin-bottom: 10px;
}
.active-btn-page {
  background: #5f8cc5;
  color: white;
}

.container-total-card {
  display: flex;
  flex-wrap: wrap; /* اجازه می‌دهد باکس‌ها در صورت کمبود فضا به خط بعد بروند */
  gap: 15px; /* فاصله بین باکس‌ها */
}

.total-card {
  flex: 1 1 20%; /* عرض پایه 20%، اما قابل کوچک و بزرگ شدن است */
  border: 1px solid #eee;
  padding: 6px 12px;
  border-radius: 8px;
  box-sizing: border-box; /* مهم برای محاسبه padding در عرض */
}

/* رسپانسیو برای موبایل */
@media (max-width: 768px) {
  .total-card {
    flex: 1 1 45%; /* دو تا در هر ردیف */
  }
}

@media (max-width: 480px) {
  .total-card {
    flex: 1 1 100%; /* هر باکس یک ردیف کامل */
  }
}
.total-card b {
  margin-right: 6px;
}

.device-list {
  margin-top: 20px;
  direction: rtl;
}

.device-card {
  border-radius: 12px;
  transition: all 0.3s;
  text-align: center;
  background: #fff;
}

.device-card:hover {
  transform: translateY(-3px);
}

.header-status-device {
  display: flex;
  justify-content: space-between;
  align-items: center;
  direction: rtl;
}

.name-status-device {
  font-weight: 600;
  font-size: 15px;
}
</style>
